<template>
  <div class="company-detail-component">
    <div v-if="!hasCompany" class="no-content">
      Не найдена
    </div>

    <template v-else-if="hasAttributes">
      <div v-if="shortName" class="company-attribute name">
        {{ shortName }}
      </div>

      <div v-if="innKppText" class="company-attribute inn-kpp">
        <span>{{ innKppText }}</span>
      </div>

      <div v-if="legalAddress" class="company-attribute address-de-jure">
        <b>Юр. адрес</b>: {{ legalAddress }}
      </div>

      <div v-if="storeAddress" class="company-attribute store-address">
        <b>Адрес склада</b>: {{ storeAddress }}
      </div>

      <div v-if="storeWorkTime" class="company-attribute store-work-time">
        <b>График работы склада</b>: {{ storeWorkTime }}
      </div>

      <div v-if="storeNotes" class="company-attribute store-notes">
        <b>Особые требования на складе</b>: {{ storeNotes }}
      </div>

      <div v-if="productionSiteName" class="company-attribute store-notes">
        <b>Производственная площадка</b>: {{ productionSiteName }}
      </div>
    </template>

    <div v-else class="company-name">
      {{ company.name ?? 'Не найдена' }}
    </div>
  </div>
</template>

<style lang="scss" src="./CompanyDetail.scss"/>

<script lang="ts">

export default defineComponent({
	name: 'CompanyDetail',

	props: {
		company: {
			type: Object,
			default: null,
		},
		store: {
			type: Object,
			default: null,
		},
		buyerProductionSite: {
			type: Object,
			default: null,
		},
	},

	computed: {
		hasCompany() {
			return this.$core.utils.isObject(this.company);
		},

		attrs() {
			return this.company?.additionalAttributes;
		},

		hasAttributes() {
			return this.$core.utils.isObject(this.attrs);
		},

		shortName() {
			return this.attrs?.nameShort?.value;
		},

		innKppText() {
			const parts = [];
			if (this.attrs?.inn?.value) parts.push(`ИНН ${this.attrs.inn.value}`);
			if (this.attrs?.kpp?.value) parts.push(`КПП ${this.attrs.kpp.value}`);
			return parts.join(' ');
		},

		legalAddress() {
			return this.attrs?.addressDeJure?.value;
		},

		storeAddress() {
			return this.store?.address?.stringRepresentation;
		},

		storeWorkTime() {
			return this.store?.workingTime;
		},

		storeNotes() {
			return this.store?.notes;
		},

		productionSiteName() {
			return this.buyerProductionSite?.name;
		},
	},
})
</script>

